import { createApp } from 'vue';
import { plugin as formKitPlugin, defaultConfig } from '@formkit/vue';
import App from "./App.vue";
import router from "./router";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap'
import '../src/assets/css/fontawesome-all.min.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'
import 'swiper/css';
import 'swiper/css/effect-fade';
import formKitConfig from '../formkit.config.js'
import '@formkit/themes/genesis'
import '@formkit/addons/css/multistep'
//import "leaflet/dist/leaflet.css"


const app = createApp(App)
app.use(router)
app.use(formKitPlugin, defaultConfig(formKitConfig))
app.mount('#app')
